export default "__VITE_ASSET__aSwX19UF__"